import { createFileRoute } from '@tanstack/react-router'
import { HttpStatusPage, httpStatusHead } from '@/components/http-status-page'
import type { HttpStatusData } from '@/components/http-status-page'

const data: HttpStatusData = {
  code: 502,
  name: 'Bad Gateway',
  description:
    'The server acting as a gateway or proxy received an invalid response from the upstream server. The reverse proxy (nginx, Cloudflare, a load balancer) is working, but the backend application server returned something it could not understand.',
  causes: [
    'The upstream application server crashed or is not running. The proxy can reach the port but gets a malformed or empty response.',
    'The application server returned a response with invalid HTTP headers or a corrupted body that the proxy cannot parse.',
    'A firewall, security group, or network issue between the proxy and the upstream server is mangling or dropping packets.',
  ],
  fixes: [
    'Check if the upstream application server is running: verify the process, check its logs, and confirm it is listening on the expected port.',
    'Restart the application server. If it crashed due to an out-of-memory error, check resource usage and increase memory limits.',
    'Review the proxy configuration. Ensure proxy_pass (nginx) or upstream settings point to the correct host and port. Check for protocol mismatches (HTTP vs HTTPS).',
  ],
  monitoringTip:
    'A 502 usually means your app server is down while the proxy layer is still healthy. Uptrack detects this within 30 seconds — much faster than waiting for user complaints. Pair Uptrack with server resource monitoring for full coverage.',
}

export const Route = createFileRoute('/_site/http/502')({
  component: () => <HttpStatusPage data={data} />,
  head: () => httpStatusHead(data),
})
